import { css, styled } from '@mui/material';

export const StyledVerticalContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledCardHeader = styled('div')(
  ({ theme }) => css`
    column-gap: ${theme.spacing('LARGE')};
    display: flex;
    justify-content: space-between;
    margin-bottom: ${theme.spacing('LARGE')};
  `
);

export const StyledCardContentLine = styled('div')`
  display: flex;
  flex-wrap: wrap;
`;
